<c1-privacy-dialog class="grv-dialog__center">
  <h3>{{ "DOWNLOAD_DATA.EXPLAINED.DIALOG_HEADER" | translate }}</h3>
  <div>
    {{ "DOWNLOAD_DATA.EXPLAINED.DIALOG_CONTENT" | translate }}
  </div>
</c1-privacy-dialog>
